export const DashboardNutritionContainer = {
  bindings: {
    activeCard: '@',
    isLoading: '<',
    index: '<',
    recipeInspiration: '<',
    recipeCollection: '<',
    mealPlan: '<',
    mealPlanList: '<',
    mealPlansCurrent: '<',
    mealPlansTotal: '<',
    subscriptionId: '<',
  },

  template: `
    <div class="dashboard-nutrition-container" ng-switch="$ctrl.activeCard">
      <section class="dashboard-cards">
        <div class="container">
          <div class="row">
            <div class="card-wrapper mb-3 mb-md-0 col-md-4 pointer"
              ng-class="{ active: $ctrl.activeCard === '1' }">
              <card-image
                card-class="text-center nutrition-{{ $ctrl.index }}-bg"
                link-text="'Discover'"
                ng-click="$ctrl.activeCard = '1'">
                <h4 class="card-title">
                  <current-day></current-day><br>
                  #FoodInspiration
                </h4>
              </card-image>
              <box-arrow-row color="white"></box-arrow-row>
              <div class="d-md-none" ng-switch-when="1">
                <dashboard-nutrition-inspiration items="$ctrl.recipeInspiration">
                </dashboard-nutrition-inspiration>
              </div>
            </div>
            <div class="card-wrapper mb-3 mb-md-0 col-md-4 pointer"
              ng-class="{ active: $ctrl.activeCard === '2' }">
              <card-image
                card-class="text-center bg-teal-dark"
                link-text="'View'"
                img="$ctrl.mealPlan.heroImage.magazine"
                ng-click="$ctrl.activeCard = '2'"
                ng-if="$ctrl.mealPlan.id">
                <i class="card-icon theme-color-secondary icon icon-meal-planner"></i>
                <small class="tagline">
                  Following Plan
                </small>
                <h4 class="card-title">
                  {{ $ctrl.mealPlan.title }}
                </h4>
              </card-image>
              <card-plain
                card-class="text-center bg-teal-dark"
                link-text="'Discover'"
                ng-click="$ctrl.activeCard = '2'"
                ng-if="!$ctrl.mealPlan.id">
                <i class="card-icon theme-color-secondary icon icon-meal-planner d-none d-md-block"></i>
                <small class="tagline">
                  Ready to plan your week?
                </small>
                <h4 class="card-title" ng-show="$ctrl.mealPlansTotal">
                  {{ $ctrl.mealPlansTotal }} Ready-made Plans
                </h4>
              </card-plain>
              <box-arrow-row color="white"></box-arrow-row>
              <div class="d-md-none" ng-switch-when="2">
                <dashboard-nutrition-meal-plan
                  meal-plan="$ctrl.mealPlan"
                  meal-plan-list="$ctrl.mealPlanList"
                  meal-plans-current="$ctrl.mealPlansCurrent"
                  meal-plans-total="$ctrl.mealPlansTotal"
                  subscription-id="$ctrl.subscriptionId">
                </dashboard-nutrition-meal-plan>
              </div>
            </div>
            <div class="card-wrapper col-md-4 pointer"
              ng-class="{ active: $ctrl.activeCard === '3' }">
              <card-image
                card-class="text-center bg-teal-dark"
                link-text="'View'"
                img="$ctrl.recipeCollection.coverImageUrl.magazine"
                ng-click="$ctrl.activeCard = '3'">
                <small class="tagline">
                  Featured
                </small>
                <h4 class="card-title">
                  {{ $ctrl.recipeCollection.title }}
                </h4>
              </card-image>
              <box-arrow-row color="white"></box-arrow-row>
              <div class="d-md-none" ng-switch-when="3">
                <dashboard-nutrition-hack
                  title="$ctrl.recipeCollection.title"
                  description="$ctrl.recipeCollection.strapLine"
                  items="$ctrl.recipeCollection.recipes"
                  hack-id="$ctrl.recipeCollection.id">
                </dashboard-nutrition-hack>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="d-none d-md-block">
        <dashboard-nutrition-inspiration
          ng-switch-when="1"
          items="$ctrl.recipeInspiration">
        </dashboard-nutrition-inspiration>
        <dashboard-nutrition-meal-plan
          ng-switch-when="2"
          meal-plan="$ctrl.mealPlan"
          meal-plan-list="$ctrl.mealPlanList"
          meal-plans-current="$ctrl.mealPlansCurrent"
          meal-plans-total="$ctrl.mealPlansTotal"
          subscription-id="$ctrl.subscriptionId">
        </dashboard-nutrition-meal-plan>
        <dashboard-nutrition-hack
          ng-switch-when="3"
          title="$ctrl.recipeCollection.title"
          description="$ctrl.recipeCollection.strapLine"
          items="$ctrl.recipeCollection.recipes"
          hack-id="$ctrl.recipeCollection.id">
        </dashboard-nutrition-hack>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/NutritionContainer.js